import styled from "styled-components";
import { Box } from "grid-styled";

import { space } from "metabase/styled-components/theme";

export const Container = styled(Box)`
  margin-bottom: ${space(1)};
  margin-top: ${space(2)};
`;
